import React from "react";

const WorkingSteps = () => {
  const steps = [
    {
      number: "01",
      title: "Choose Your Cab",
      description:
        "Choose from our comfortable cabs based on your trip, group size and travel requirements.",
    },
    {
      number: "02",
      title: "Share Your Trip",
      description:
        "Share your pickup point, destination and travel date with our booking team easily.",
    },
    {
      number: "03",
      title: "Confirm Your Booking",
      description:
        "Confirm your cab, travel details and fare with our team before your journey begins.",
    },
    {
      number: "04",
      title: "Enjoy Your Journey",
      description:
        "Meet your driver on time and enjoy a safe, comfortable and hassle-free journey.",
    },
  ];

  return (
    <div
      className="section-full py-3 site-bg-white twm-w-steps-section-wrap wow fadeInDown bhgh"
      data-wow-offset="100"
      data-wow-delay="0.2"
      style={{
        backgroundImage: "url('/images/step-bg.jpg')",
      }}
    >
      <div className="container">

        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">
            Easy Cab Booking
          </div>

          <h2 className="twm-large-title site-text-dark">
            Easy & Quick Cab Booking
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-steps-section">

            {steps.map((step, index) => (
              <div
                className="col-lg-3 col-md-6 m-b30"
                key={index}
              >
                <div className="twm-w-steps">

                  {/* Step Number */}
                  <div className="twm-w-step-count">
                    <span>{step.number}</span>
                  </div>

                  {/* Step Content */}
                  <div className="twm-w-step-detail">
                    <h3 className="twm-title">
                      {step.title}
                    </h3>

                    <p>{step.description}</p>
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default WorkingSteps;
